import { useState } from "react";
import { Button } from "primereact/button";
import { Badge } from "primereact/badge";
import { ConfirmPopup } from "primereact/confirmpopup";

const BannerPreview = ({ onEdit }) => {
    const [visible, setVisible] = useState(false);

    const badgeStyle = {
        background: '#00BCD4',
        color: '#fff',
        animation: 'pulse 1.2s infinite',
        fontWeight: 700,
        fontSize: '0.85rem',
        border: '2px solid #fff',
        boxShadow: '0 0 0 2px #00BCD4',
    };

    // Keyframes para animação do pulso
    const pulseKeyframes = `
    @keyframes pulse {
        0% { box-shadow: 0 0 0 0 #00BCD4; }
        70% { box-shadow: 0 0 0 8px rgba(0,188,212,0); }
        100% { box-shadow: 0 0 0 0 #00BCD4; }
    }`;

    // Keyframes para animação do sino
    const bellKeyframes = `
    @keyframes bell-shake {
        0% { transform: rotate(0deg); }
        10% { transform: rotate(-15deg); }
        20% { transform: rotate(10deg); }
        30% { transform: rotate(-10deg); }
        40% { transform: rotate(6deg); }
        50% { transform: rotate(-4deg); }
        60% { transform: rotate(2deg); }
        70% { transform: rotate(-1deg); }
        80% { transform: rotate(0deg); }
        100% { transform: rotate(0deg); }
    }`;

    const handleEdit = () => {
        setVisible(false);
        if (onEdit) onEdit();
    };

    return (
        <>
            <style>{pulseKeyframes + bellKeyframes}</style>
            <div style={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                zIndex: 1100,
                display: 'flex',
                alignItems: 'center',
                gap: 8
            }}>
                <div style={{ position: 'relative', width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button
                        className="p-button-rounded p-button-info banner-preview-btn"
                        style={{ width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}
                        onClick={(e) => setVisible(true)}
                        aria-label="Preview do Template"
                    >
                        <span className="pi pi-bell" style={{ animation: 'bell-shake 1.5s infinite', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, width: '100%', height: '100%' }} />
                    </Button>
                    <Badge
                        value={"!"}
                        style={{
                            ...badgeStyle,
                            position: 'absolute',
                            top: -4,
                            right: -4,
                            minWidth: 16,
                            minHeight: 16,
                            width: 18,
                            height: 18,
                            fontSize: '0.7rem',
                            padding: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        className="p-badge-lg"
                    />
                </div>
                <ConfirmPopup
                    className="banner-preview-confirm-popup"
                    target={document.querySelector('.banner-preview-btn')}
                    visible={visible}
                    onHide={() => setVisible(false)}
                    message={
                        <div style={{ textAlign: 'center' }}>
                            <div className="mb-2">
                                <i className="pi pi-info-circle"
                                   style={{ fontSize: 28, color: '#00BCD4', display: 'block', margin: '0 auto' }} />
                            </div>
                            <div>Este é um template de visualização. Deseja editar este template?</div>
                        </div>
                    }
                    icon={null}
                    acceptLabel={<span style={{ fontSize: '0.85rem', padding: '2px 10px', display: 'flex', alignItems: 'center', gap: 4 }}><i className="pi pi-check" style={{ fontSize: 14, marginRight: 4 }} />Editar</span>}
                    rejectLabel={<span style={{ fontSize: '0.85rem', padding: '2px 10px', display: 'flex', alignItems: 'center', gap: 4, color: '#e53935' }}><i className="pi pi-times" style={{ fontSize: 14, marginRight: 4, color: '#e53935' }} />Fechar</span>}
                    acceptClassName="p-button-sm p-button-info fw-bold"
                    rejectClassName="p-button-sm p-button-outlined p-button-danger fw-bold"
                    accept={handleEdit}
                    reject={() => setVisible(false)}
                    style={{ minWidth: 180, maxWidth: 320 }}
                />
                <style>{`
                    .banner-preview-confirm-popup .p-confirm-popup-footer {
                      display: flex !important;
                      flex-direction: row !important;
                      justify-content: space-between !important;
                      align-items: center !important;
                      gap: 16px !important;
                    }
                `}</style>
            </div>
        </>
    );
};

export default BannerPreview;
